import { createRouter, createWebHashHistory } from 'vue-router';
import MainView from '../views/HomePage.vue';
import ResultsPage from '@/views/ResultsPage.vue';

import store from '@/store';

const routes = [
    {
        path: '/',
        name: 'home',
        component: MainView
    },
    {
        path: '/results',
        name: 'results',
        component: ResultsPage,
    },

    {
        path: '/location',
        name: 'LocationViewer',
        component: () => import('../views/DeputyWindow.vue')
    }
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

router.beforeEach(async (to, from, next) => {
    // 如果没有用户信息，则获取用户信息
    if (!store.state.name) {
        // await store.dispatch('fetchUserInfo');
        store.commit('setUserInfo', {
            userName:  'UnLogin User',
            userAvatar: '/user-avatar.png',
        });
    } else {
        console.log("store.state.name", store.state.name)
    }
    next();
});

export default router;
